function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgRefresh(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M48 4C23.7 4 4 23.699 4 48s19.7 44 44 44 44-19.699 44-44S72.3 4 48 4zm0 80c-19.882 0-36-16.118-36-36s16.118-36 36-36 36 16.118 36 36-16.118 36-36 36z"
  }), React.createElement("path", {
    d: "M32.665 49c.037 0 .074-.011.111-.013.037.002.074.013.111.013.626 0 1.258-.195 1.797-.6l4.667-3.5a3 3 0 00.6-4.2 2.98 2.98 0 00-2.349-1.187c2.167-4.452 6.451-8.263 12.569-8.263 8.348 0 12.987 6.032 13.883 12.01a4 4 0 007.912-1.185C70.307 30.991 61.344 23.25 50.172 23.25c-11.38 0-18.684 8.148-21.193 16.429A2.989 2.989 0 0025.6 40.7a3 3 0 00.6 4.2l4.667 3.5c.54.405 1.171.6 1.798.6zM72.352 53.6l-4.667-3.5a2.974 2.974 0 00-1.909-.583 2.97 2.97 0 00-1.908.583L59.2 53.6a3 3 0 001.801 5.4c.043 0 .085-.008.127-.01-1.763 3.879-5.308 7.197-11.259 7.647-7.129.538-12.853-3.324-15.289-10.334a4 4 0 10-7.557 2.627c3.381 9.729 11.738 15.754 21.594 15.754.612 0 1.231-.022 1.854-.07 9.562-.722 16.78-6.778 19.193-15.75a2.995 2.995 0 003.288-1.064 3 3 0 00-.6-4.2z"
  }));
}

SvgRefresh.clsName = 'icon-www__refresh';
SvgRefresh.remarkName = 'unknown';
export default SvgRefresh;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Refresh.js
// module id = 2416
// module chunks = 17 18